import React, { useEffect,useState } from 'react';
import axios from 'axios';
import { instance } from './common';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import './styles/App.css';







function Test() {


  const [inputs2, setInputs2] = useState({
    u_login_id: '',
});
  const {u_login_id} = 'admin';

  const push = () => {
      

    const fetchData = async () => {
      instance.post('/users/push_test').then(function(res){
           
            // alert('푸쉬알림이 보내졌습니다.');
            
        });

    };

    fetchData();
}


const push2 = () => {
  let obj = {}
const fetchData = async () => {
  instance.post('/users/update/pwd',obj).then(function(res){

     
      alert('푸쉬알림이 보내졌습니다.');
      
  });

};

fetchData();
}


const push3 = () => {
  let obj = {}
const fetchData = async () => {
  instance.post('/users/',obj).then(function(res){

      alert('푸쉬알림이 보내졌습니다.');
      
  });

};

fetchData();
}


  return (
    <>
    <h3>안녕하세요</h3>
    <input className="btn btn-primary" onClick={push} type="button" value="푸쉬알림1" />
    <input className="btn btn-primary" onClick={push2} type="button" value="푸쉬알림2" />
    <input className="btn btn-primary" onClick={push3} type="button" value="푸쉬알림3" />
    </>
  );
}

export default Test;